import { useEffect } from 'react';
import { useTour } from '@/contexts/useTour';
import { TourSpotlight } from './TourSpotlight';
import { TourTooltip } from './TourTooltip';

export function ProductTour() {
  const {
    currentTour,
    currentStep,
    isActive,
    nextStep,
    previousStep,
    skipTour,
    dismissTour,
  } = useTour();

  // Prevent body scroll when tour is active
  useEffect(() => {
    if (isActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isActive]);

  // Handle escape key to close tour
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isActive) {
        dismissTour();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isActive, dismissTour]);

  if (!isActive || !currentTour) {
    return null;
  }

  const step = currentTour.steps[currentStep];

  return (
    <>
      <TourSpotlight step={step} isActive={isActive} />
      <TourTooltip
        step={step}
        currentStep={currentStep}
        totalSteps={currentTour.steps.length}
        onNext={nextStep}
        onPrevious={previousStep}
        onSkip={skipTour}
        onClose={dismissTour}
      />
    </>
  );
}
